import { render, staticRenderFns } from "./assignUserRole.vue?vue&type=template&id=697c2b5a&lang=pug&"
import script from "./assignUserRole.vue?vue&type=script&lang=js&"
export * from "./assignUserRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports